var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'user_info', params: {userId: _vm.user.id}}}},[_vm._v("\n  "+_vm._s(_vm._f("getUserFullName")(_vm.user))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }